import axios from 'axios';

const apiURL = process.env.REACT_APP_API_BASE_URL;

export const axiosPublic = axios.create({
    baseURL: apiURL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});
